import { type ReactNode } from "react";

import { Button } from "./button";
import { Dialog } from "./dialog";

type Props = {
  isOpen: boolean;
  isLoading?: boolean;
  onOpenChange: (isOpen: boolean) => void;
  title: ReactNode;
  description: ReactNode;
  cancelText: ReactNode;
  confirmText: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmDialog = (props: Props) => {
  const {
    title,
    isLoading,
    description,
    isOpen,
    onOpenChange,
    cancelText,
    confirmText,
    onCancel,
    onConfirm,
  } = props;
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description>{description}</Dialog.Description>

        <div className="flex flex-col gap-2">
          <Button theme="secondary" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button isLoading={isLoading} theme="danger" onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};
